import * as React from 'react';
import { render } from 'react-dom';
import { PrivacyPolicy } from '../landing_pages/pages/PrivacyPolicy';
import '../terms_and_conditions/styles.scss';


const root = document.getElementById('privacy_policy');
render(<PrivacyPolicy />, root);
